import { useSelector } from "react-redux";
import { Button, Typography } from "@mui/material";

const GradientButton = ({
  height = 50,
  width = "80%",
  sx = {},   // <-- use sx instead of style
  onClick,
  text = "Radiant Button",
  ...props
}) => {
  const theme = useSelector((state) => state.themeValue.colors);

  return (
    <Button
      onClick={onClick}
      variant="contained"
      disableElevation
      sx={{
        borderRadius:3,
        width,
        height,
        // background: `linear-gradient(90deg, ${theme.primary_gradient_start_color}, ${theme.primary_gradient_end_color})`,
        background:'primary.main',
        color: "white",
        fontWeight: "bold",
        fontSize: 16,
        textTransform: "none",
        ...sx,   
      }}
      {...props}
    >
      <Typography sx={{ fontWeight:'bold'}}>{text}</Typography>
    </Button>
  );
};

export default GradientButton;
